'use strict';

var router = undefined;

// Assign to module.exports before any requires
module.exports = {
  getCurrentPath: function getCurrentPath() {
    return router.getCurrentPath();
  },

  makePath: function makePath(to, params, query) {
    return router.makePath(to, params, query);
  },

  makeHref: function makeHref(to, params, query) {
    return router.makeHref(to, params, query);
  },

  transitionTo: function transitionTo(to, params, query) {
    router.transitionTo(to, params, query);
  },

  replaceWith: function replaceWith(to, params, query) {
    router.replaceWith(to, params, query);
  },

  goBack: function goBack() {
    router.goBack();
  },

  run: function run(render) {
    router.run(render);
  }
};

var Router = require('react-router');
var routes = require('routes/main');

router = Router.create({
  routes: routes,
  location: Router.HistoryLocation
});


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/routers/main.js
 **/